import { useAppSelector } from "@/utils";
import { Bank, Flex, LegacyCardList, Space, Typography, usePaypingContext } from "@payping/web-components";
import { DisplayModeEnum } from "@payping/web-components/legacyComponents/List/types";
import type { ListCardProps } from "@payping/web-components/legacyComponents/List/types";
import { formatLocalizedNumber } from "@payping/utilities-shared/number";
import { CuToman } from "@payping/icons";
import { getBankInfoFromSheba } from "@payping/utilities-shared/bank";

const SamanShowList = () => {
  const paymentDetailsModels = useAppSelector((state) => state.digitalAccount.saman.requestList?.paymentDetailsModels);
  const { breakpoints } = usePaypingContext();
  const { md } = breakpoints;

  const data: ListCardProps["dataSource"] = (paymentDetailsModels ?? []).map((transfer) => ({
    actions: [
      <Flex align="center" key={0}>
        <Typography.Text key={1}>{`${formatLocalizedNumber({ value: (transfer?.amount || 0) / 10 })}`}</Typography.Text>
        <CuToman width={24} height={24} />
      </Flex>,
    ],
    content: [
      <Flex key={1} vertical={!md} gap={16}>
        <Space>
          <Typography.Text type={"secondary"}>{transfer?.iban}</Typography.Text>
          <Bank.Icon showTooltip bankName={getBankInfoFromSheba(transfer?.iban ?? "")?.name} />
        </Space>
      </Flex>,
    ],
    title: { primary: transfer.fullName },
    key: transfer.amount || "",
  }));

  return (
    <LegacyCardList
      grid={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1, xxxl: 1, column: 0 }}
      dataSource={data}
      mode={md ? DisplayModeEnum.List : DisplayModeEnum.Card}
    />
  );
};

export default SamanShowList;
